import React, { useState } from "react";
import { Grid, IconButton, Tooltip, Typography, Divider } from "@mui/material";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import DeleteIcon from "@mui/icons-material/Delete";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import CloseIcon from "@mui/icons-material/Close";

const WHLocationTypeActionMenu = ({
  isEdit,
  onSave,
  onDelete,
  onExit,
  onClear,
  saveDisabled,
}) => {
  const [selectedButton, setSelectedButton] = useState(null);

  const handleClick = (btn) => {
    setSelectedButton(btn);
    if (btn === "save") onSave();
    else if (btn === "delete") onDelete();
    else if (btn === "clear") onClear();
    else if (btn === "exit") onExit();
  };

  return (
    <Grid container justifyContent="space-between" alignItems="center" padding={0}>
      {/* Left-aligned Title */}
      <Grid item>
        <Typography
          variant="h4"
          sx={{ textAlign: "center", width: "100%", marginLeft: "10px", alignItems: "center" }}
        >
          {isEdit ? "Edit Location Type" : "New Location Type"}
        </Typography>
      </Grid>

      {/* Right-aligned Buttons */}
      <Grid item>
        <Grid container alignItems="center">
          <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

          {/* Save */}
          <Grid item ml={1} mr={1}>
            <Tooltip title="Save Location Type">
              <IconButton
                onClick={() => handleClick("save")}
                sx={{ display: "flex", alignItems: "center" }}
                disabled={saveDisabled}
              >
                <SaveAltIcon
                  style={{
                    fontSize: "18px",
                    color: selectedButton === "save" ? "yellow" : "#009688",
                  }}
                />
                <Typography variant="body2" sx={{ ml: 1 }}>
                  Save
                </Typography>
              </IconButton>
            </Tooltip>
          </Grid>

          {/* Delete (only in edit mode) */}
          {isEdit && (
            <>
              <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
              <Grid item ml={1} mr={1}>
                <Tooltip title="Delete Location Type">
                  <IconButton
                    onClick={() => handleClick("delete")}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <DeleteIcon style={{ fontSize: "18px", color: "#d72c0dff" }} />
                    <Typography variant="body2" sx={{ ml: 1 }}>
                      Delete
                    </Typography>
                  </IconButton>
                </Tooltip>
              </Grid>
            </>
          )}

          <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

          {/* Clear */}
          <Grid item ml={1} mr={1}>
            <Tooltip title="Clear Location Type Details">
              <IconButton
                onClick={() => handleClick("clear")}
                sx={{ display: "flex", alignItems: "center" }}
              >
                <ClearAllIcon style={{ fontSize: "18px", color: "#e0d620ff" }} />
                <Typography variant="body2" sx={{ ml: 1 }}>
                  Clear
                </Typography>
              </IconButton>
            </Tooltip>
          </Grid>

          <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

          {/* Exit */}
          <IconButton onClick={() => handleClick("exit")}>
            <CloseIcon style={{ fontSize: "14px", color: "#2196F3" }} />
          </IconButton>
          <Divider orientation="vertical" flexItem />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default WHLocationTypeActionMenu;
